export default {
  lang: {
    zh: '中文',
    en: 'English',
    lo: 'ລາວ',
    th: 'ไทย',
    select: 'เลือกภาษา',
  },
  nav: {
    home: 'หน้าแรก',
    services: 'บริการ',
    projects: 'โครงการ',
    news: 'ข่าว',
    contact: 'ติดต่อ',
    bookNow: 'จองเลย',
    menu: 'เมนู',
  },
  footer: {
    tagline: 'บริการที่ปรึกษาและโครงการที่เชื่อถือได้ ช่วยธุรกิจเปลี่ยนผ่านสู่ดิจิทัล',
    quickLinks: 'ลิงก์ด่วน',
    services: 'บริการ',
    projects: 'โครงการ',
    news: 'ข่าว',
    contact: 'ติดต่อเรา',
    contactInfo: 'ข้อมูลติดต่อ',
    email: 'อีเมล',
    phone: 'โทรศัพท์',
    workHours: 'เวลาทำการ',
    copyright: '© {year} Wanyuntang สงวนลิขสิทธิ์',
  },
  brand: {
    name: 'Wanyuntang',
    subtitle: 'ที่ปรึกษาธุรกิจ · บริการโครงการ',
  },
  common: {
    loading: 'กำลังโหลด...',
    empty: 'ไม่มีข้อมูล',
    latest: 'ล่าสุด',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    save: 'บันทึก',
    refresh: 'รีเฟรช',
    refreshing: 'กำลังรีเฟรช...',
    readMore: 'อ่านต่อ →',
    backToList: '← กลับไปรายการข่าว',
    backToNews: 'กลับไปรายการ',
  },
  home: {
    badge: 'มืออาชีพ · เชื่อถือได้ · มีประสิทธิภาพ',
    title: 'ช่วยธุรกิจเปลี่ยนผ่านดิจิทัลและเติบโต',
    desc: 'Wanyuntang ให้บริการเว็บไซต์ ร้านค้าออนไลน์ และโครงการแสดงสินค้าแบบครบวงจร',
    bookNow: 'จองเลย',
    learnServices: 'ดูบริการ',
    statProjects: 'โครงการสำเร็จ',
    statSatisfaction: 'ความพึงพอใจ',
    statSupport: 'สนับสนุน',
    servicesTitle: 'บริการของเรา',
    servicesSubtitle: 'โซลูชันดิจิทัลครบวงจรตั้งแต่แบรนด์ถึงการขาย',
    viewAllServices: 'ดูบริการทั้งหมด →',
    projectsTitle: 'โครงการยอดนิยม',
    projectsSubtitle: 'เลือกประเภทโครงการและจองปรึกษาได้ทันที',
    newsTitle: 'ข่าวล่าสุด',
    newsSubtitle: 'ข่าวบริษัทและข้อมูลอุตสาหกรรม',
    ctaTitle: 'พร้อมเริ่มโครงการแล้วหรือยัง?',
    ctaDesc: 'ส่งแบบฟอร์ม ที่ปรึกษาจะติดต่อภายใน 24 ชั่วโมง',
    ctaBtn: 'ปรึกษาฟรี',
    service1Title: 'เว็บไซต์องค์กร',
    service1Desc: 'ออกแบบตอบสนอง SEO เพิ่มภาพลักษณ์แบรนด์',
    service2Title: 'แพลตฟอร์มอีคอมเมิร์ซ',
    service2Desc: 'จัดการสินค้า คำสั่งซื้อ และการชำระเงิน',
    service3Title: 'เว็บแสดงสินค้า',
    service3Desc: 'ภาพสวยงาม เน้นจุดเด่นผลิตภัณฑ์',
  },
  services: {
    title: 'บริการ',
    subtitle: 'โซลูชันดิจิทัลครบวงจรเพื่อพัฒนาธุรกิจ',
    bookConsult: 'จองปรึกษา',
    s1Title: 'พัฒนาเว็บไซต์องค์กร',
    s1Desc: 'สร้างเว็บไซต์มืออาชีพ เพิ่มความน่าเชื่อถือและลูกค้าใหม่',
    s1f1: 'ออกแบบตอบสนองทุกอุปกรณ์',
    s1f2: 'SEO',
    s1f3: 'ระบบ CMS',
    s1f4: 'ประสิทธิภาพและความปลอดภัย',
    s2Title: 'พัฒนาร้านค้าออนไลน์',
    s2Desc: 'ร้านค้าครบวงจร จัดการสินค้า คำสั่ง และชำระเงิน',
    s2f1: 'จัดการสินค้าและสต็อก',
    s2f2: 'ตะกร้าและคำสั่งซื้อ',
    s2f3: 'ชำระเงินและขนส่ง',
    s2f4: 'สมาชิกและการตลาด',
    s3Title: 'เว็บแสดงสินค้า',
    s3Desc: 'ภาพสวยดึงดูดลูกค้าและเพิ่มการแปลง',
    s3f1: 'ออกแบบและแอนิเมชัน',
    s3f2: 'หน้ารายละเอียดสินค้า',
    s3f3: 'สื่อมัลติมีเดีย',
    s3f4: 'วิเคราะห์ข้อมูล',
    s4Title: 'ที่ปรึกษาธุรกิจ',
    s4Desc: 'ที่ปรึกษาการเปลี่ยนผ่านดิจิทัลตั้งแต่เริ่มจนส่งมอบ',
    s4f1: 'สำรวจความต้องการ',
    s4f2: 'ออกแบบโซลูชัน',
    s4f3: 'วางแผนโครงการ',
    s4f4: 'สนับสนุนต่อเนื่อง',
  },
  projects: {
    title: 'โครงการ',
    subtitle: 'เลือกประเภทโครงการและจองได้ทันที',
    empty: 'ยังไม่มีโครงการ',
    bookProject: 'จองโครงการนี้',
  },
  projectItems: {
    building: {
      name: 'เว็บไซต์องค์กร',
      desc: 'เว็บไซต์องค์กรที่ตอบสนองทุกอุปกรณ์ เพิ่มภาพลักษณ์แบรนด์และลูกค้าใหม่',
    },
    cart: {
      name: 'แพลตฟอร์มอีคอมเมิร์ซ',
      desc: 'ระบบร้านค้าครบวงจร รองรับสินค้า คำสั่งซื้อ และการชำระเงิน',
    },
    sparkle: {
      name: 'เว็บแสดงสินค้า',
      desc: 'เว็บแสดงผลิตภัณฑ์สวยงาม เน้นจุดเด่นและประสบการณ์ภาพ',
    },
  },
  news: {
    title: 'ข่าวสาร',
    subtitle: 'ข่าวอุตสาหกรรมและบริษัท',
    empty: 'ยังไม่มีข่าว',
    notFound: 'ไม่พบข่าวหรือถูกลบแล้ว',
  },
  contact: {
    title: 'ติดต่อเรา',
    subtitle: 'ติดต่อผ่านช่องทางด้านล่าง หรือจองผ่านหน้าโครงการ',
    emailLabel: 'อีเมล',
    phoneLabel: 'สายด่วน',
    hoursLabel: 'เวลาทำการ',
    addressLabel: 'ที่อยู่',
    bookOnline: 'จองออนไลน์',
    formTitle: 'ฝากข้อความ',
    formDesc: 'กรอกข้อมูลแล้วเราจะติดต่อกลับโดยเร็ว',
    name: 'ชื่อ',
    namePh: 'ชื่อของคุณ',
    email: 'อีเมล',
    emailPh: "name{'@'}example.com",
    address: 'ที่อยู่',
    addressPh: 'ที่อยู่ของคุณ (ไม่บังคับ)',
    message: 'ข้อความ',
    messagePh: 'อธิบายความต้องการ',
    submit: 'ส่งข้อความ',
    fillRequired: 'กรุณากรอกชื่อและอีเมล',
    submitSuccess: 'ได้รับข้อความแล้ว เราจะติดต่อกลับเร็วๆ นี้!',
    submitFail: 'ส่งไม่สำเร็จ กรุณาลองใหม่',
    defaultEmail: "contact{'@'}wanyuntang.com",
    defaultPhone: '400-888-0000',
    defaultAddress: 'จีน · ศูนย์บริการที่ปรึกษาธุรกิจ',
    defaultWorkHours: 'จันทร์ – ศุกร์ 9:00 – 18:00 น.',
  },
  appointment: {
    title: 'จองโครงการ',
    close: 'ปิด',
    name: 'ชื่อ',
    namePh: 'กรอกชื่อของคุณ',
    nameErr: 'กรุณากรอกอย่างน้อย 2 ตัวอักษร',
    email: 'อีเมล',
    emailErr: 'กรุณากรอกอีเมลที่ถูกต้อง',
    phone: 'โทรศัพท์',
    phonePh: 'ไม่บังคับ',
    date: 'วันที่',
    dateErr: 'กรุณาเลือกวันที่',
    slot: 'ช่วงเวลา',
    slotPh: 'เลือกช่วงเวลา',
    slotErr: 'กรุณาเลือกช่วงเวลา',
    address: 'ที่อยู่',
    addressPh: 'ไม่บังคับ',
    note: 'หมายเหตุ',
    notePh: 'อธิบายความต้องการ',
    submitting: 'กำลังส่ง...',
    submit: 'ยืนยันการจอง',
    success: 'ส่งการจองแล้ว เราจะติดต่อกลับเร็วๆ นี้!',
    fail: 'ส่งไม่สำเร็จ กรุณาลองใหม่',
    datePh: 'เลือกวันที่',
    yearPh: 'ปี',
    monthPh: 'เดือน',
    dayPh: 'วัน',
    slot1: '09:00–10:00',
    slot2: '10:00–11:00',
    slot3: '11:00–12:00',
    slot4: '14:00–15:00',
    slot5: '15:00–16:00',
    slot6: '16:00–17:00',
  },
  admin: {
    title: 'แผงควบคุม',
    subtitle: 'ระบบจัดการเว็บไซต์ Wanyuntang',
    username: 'ชื่อผู้ใช้',
    usernamePh: 'กรอกชื่อผู้ดูแล',
    password: 'รหัสผ่าน',
    passwordPh: 'กรอกรหัสผ่าน',
    showPwd: 'แสดง',
    hidePwd: 'ซ่อน',
    remember: 'จำชื่อผู้ใช้',
    login: 'เข้าสู่ระบบ',
    loggingIn: 'กำลังเข้าสู่ระบบ...',
    loggedIn: 'เข้าสู่ระบบแล้ว · {user}',
    logout: 'ออกจากระบบ',
    loginSuccess: 'เข้าสู่ระบบสำเร็จ',
    loginFail: 'เข้าสู่ระบบไม่สำเร็จ',
    fillCredentials: 'กรุณากรอกชื่อผู้ใช้และรหัสผ่าน',
    sessionExpired: 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่',
    loadFail: 'โหลดข้อมูลไม่สำเร็จ',
    appointments: 'จัดการการจอง',
    noAppointments: 'ไม่มีการจอง',
    colName: 'ชื่อ',
    colContact: 'อีเมล / โทร',
    colProject: 'โครงการ',
    colTime: 'เวลา',
    colStatus: 'สถานะ',
    colAction: 'การดำเนินการ',
    confirmBtn: 'ยืนยัน',
    cancelBtn: 'ยกเลิก',
    statusPending: 'รอยืนยัน',
    statusConfirmed: 'ยืนยันแล้ว',
    statusCancelled: 'ยกเลิกแล้ว',
    statusUpdated: 'อัปเดตสถานะแล้ว',
    updateFail: 'อัปเดตไม่สำเร็จ',
    messages: 'จัดการข้อความ',
    noMessages: 'ไม่มีข้อความ',
    colAddress: 'ที่อยู่',
    colMessage: 'ข้อความ',
    colCreated: 'วันที่ส่ง',
    markRead: 'ทำเครื่องหมายว่าอ่านแล้ว',
    markUnread: 'ทำเครื่องหมายว่ายังไม่อ่าน',
    statusUnread: 'ยังไม่อ่าน',
    statusRead: 'อ่านแล้ว',
    contactSettings: 'ตั้งค่าที่อยู่ติดต่อ',
    contactSettingsDesc: 'แสดงบนหน้าติดต่อของเว็บไซต์',
    saveContact: 'บันทึกข้อมูลติดต่อ',
    contactSaved: 'บันทึกข้อมูลติดต่อแล้ว',
    publishNews: 'เผยแพร่ข่าว',
    editNews: 'แก้ไขข่าว',
    newsTitle: 'หัวข้อ',
    newsSummary: 'สรุป',
    newsContent: 'เนื้อหา',
    newsDate: 'วันที่เผยแพร่ (เช่น 2026-07-03)',
    publish: 'เผยแพร่',
    saveEdit: 'บันทึกการแก้ไข',
    cancelEdit: 'ยกเลิกการแก้ไข',
    existingNews: 'ข่าวที่มีอยู่',
    noNews: 'ไม่มีข่าว',
    edit: 'แก้ไข',
    fillNews: 'กรุณากรอกหัวข้อและเนื้อหา',
    newsPublished: 'เผยแพร่ข่าวแล้ว',
    newsUpdated: 'อัปเดตข่าวแล้ว',
    opFail: 'ดำเนินการไม่สำเร็จ',
  },
}
